export default __webpack_public_path__ + "static/media/gallery3.b99a7fe0.jpg";